import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFProductWinAdd } from '@/components/UI/svg/mm100';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({ callBack, type }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    const list = [
        {
            src: ['listC1.webp', 'listC1.png'],
            title: t('presale.product.listC_list_title1'),
            show: type === 'rv',
        },
        {
            src: ['listC2.webp', 'listC2.png'],
            title: t('presale.product.listC_list_title2'),
            show: type === 'rv',
        },
        {
            src: ['listC3.webp', 'listC3.png'],
            title: t('presale.product.listC_list_title3'),
            show: type === 'rv',
        },
        {
            src: ['listC4.webp', 'listC4.png'],
            title: t('presale.product.listC_list_title4'),
            show: ['offGrid', 'home'].includes(type) || !type,
        },
        {
            src: ['listC5.webp', 'listC5.png'],
            title: t('presale.product.listC_list_title3'),
            show: ['offGrid', 'home'].includes(type) || !type,
        },
    ];

    return (
        <div className={`${css.listC} listC`}>
            <div className="kit-ms1">{t('presale.product.listC_ms1')}</div>
            <div className="kit-ms2">{t('presale.product.listC_ms2')}</div>
            <div className="kit-ms3">{t(locale === 'kr' ? 'presale.product.listC_ms3_h5' : 'presale.product.listC_ms3')}</div>
            <div className="kit-ms4">{t('presale.product.listC_ms4')}</div>
            <div className="more-win-fun" onClick={() => callBack('SolarPanels')}>
                {t('presale.product.h5_learn_more')}
                <span className="more-win-fun-icon">
                    <EFProductWinAdd />
                </span>
            </div>
            <div className="list-box">
                <Swiper
                    effect="fade"
                    pagination={{
                        clickable: true,
                    }}
                    loop={true}
                >
                    {list?.map((item: any, index: number) => {
                        return (
                            item.show && (
                                <SwiperSlide key={index}>
                                    <div className="list-item">
                                        <EFPic name={[item.src[0], item.src[1]]} className="fullImgs" alt={item.title} />
                                        <div className="list-ms">{item.title}</div>
                                        <div className="list-link ef-blue-link">
                                            <a href={undefined} onClick={() => callBack('SolarPanels')}>
                                                {t('presale.product.listC_learn_more')}
                                                <span className="ef-blue-link-more">{'>'}</span>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
}
